export const parseIdentifier = (identifier) => {
    const parts = identifier.split('&');
    const result = {};
    for (const part of parts) {
        const [key, value] = part.split('=');
        result[key] = value;
    }
    return result;
};
export const parseIdentifierToQueryString = (identifier) => {
    const parts = Object.entries(identifier).map(([key, value]) => `${key}=${value}`);
    return parts.join('&');
};
